<template>
    <div class="col-12">
        <div v-show="uploadDocumentsElement">
            <div class=" row text-center m-5">
                <h2 class="ui inverted purple text"><strong> Update Documents</strong>
                </h2>
                <p class="text-muted fw-light m-3">Please provide the documents <br />indicated below</p>
                <p>Copy of ID, Proof of residence, Passport sized photos</p>
                <small>To avoid delays, make sure your documents are clear.</small>
            </div>

            <div class="row d-flex justify-content-center align-items-center mt-5">
                <div class="col-11 col-lg-9">
                    <form v-bind:class="{ 'ui form loading': isBusy() }" @submit.prevent="uploadFiles()">
                        <div class="row">
                            <div class="col d-flex align-items-center">
                                <a-select @change="startImageUpload" placeholder="Choose a document type" allowClear>
                                    <a-select-option v-for="fileType of model.fileTypes" :key="fileType.label"
                                        :value="fileType.label">
                                        {{ fileType.name }}
                                    </a-select-option>
                                </a-select>
                            </div>
                        </div>

                        <br />

                        <a-upload-dragger v-if="showFileUploader" name="file" :before-upload="beforeUpload"
                            @change="storeImageUpload">
                            <p class="ant-upload-drag-icon">
                                <InboxOutlined style="color:purple" />
                            </p>
                            <p class="ant-upload-text">
                                Click or drag file to this area to upload
                            </p>
                            <p class="ant-upload-hint">
                                You can upload multiple files at once
                            </p>
                        </a-upload-dragger>

                        <div v-if="model.files.length > 0">
                            <div class="row mt-5">
                                <p class="col-3 h6">Doc Type</p>
                                <p class="col-5 h6">File name</p>
                                <p class="col-3 h6 text-right">Size</p>
                                <p class="col"></p>
                            </div>
                            <div v-for="file of model.files" :key="file.docType" class="row border-top mt-1 pt-1">
                                <p class="col-3">{{ file.docType }}</p>
                                <p class="col-5">{{ file.file.name }}</p>
                                <p class="col-3 text-right">{{ (file.file.size / 1028).toFixed(2) }} KB</p>
                                <p class="col text-danger" style="cursor:pointer" @click="removeItem(file)">X</p>
                            </div>
                        </div>

                        <small v-if="errors.otp" class="text-danger">{{ errors.otp }}</small>
                        <small v-if="errors.messageNotReadable" class="text-danger">{{
                            errors.messageNotReadable
                        }}</small>
                        <small v-if="errors.generalExceptionx" class="text-danger">{{
                            errors.generalException
                        }}</small>
                        <small v-if="errors.apiException" class="text-danger">{{
                            errors.apiException
                        }}</small>

                        <button class="ui button  purple fluid mt-4" :disabled="!isFormValid" type="submit">Upload
                            Documents</button>
                        <button class="ui button  grey fluid mt-4 mb-4" @click="back()">Back</button>
                    </form>
                </div>
            </div>
        </div>
        <div v-show="makePaymentElement">
            <div class=" row text-center m-5">
                <h3 v-if="success" class="ui inverted purple text"> <strong> {{ title
                }}</strong>
                </h3>
                <h3 v-if="!success" class="ui inverted purple text"><strong> {{
                    title
                }}</strong>
                </h3>

            </div>
            <div class="row d-flex justify-content-center align-items-center mt-5">
                <div class="col-11 col-lg-9">
                    <div class="ui violet floating message m-4">
                        <div class="header mb-2">
                            <div v-if="loadingRequest" class="ui active inline loader"></div>
                            {{ subTitle }}
                        </div>
                        <p> {{ message }}</p>
                    </div>
                    <button v-if="retryButton" class="ui button  purple fluid mt-4 mb-4" @click="uploadFiles()">Retry
                        Payment</button>
                    <button v-if="logoutButton" class="ui button  grey fluid mt-4 mb-4" @click="login()">Logout</button>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import baseMethods from "@/utils/baseMethods";
import { URLS } from "@/utils/constants";
import { http } from "@/utils/http";
import { utils } from "@/utils/utils";
import { InboxOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';

export default {
    name: "UpdateT24Documents",
    components: {
        InboxOutlined,
    },
    data() {
        return {
            subTitle: '',
            title: '',
            message: '',
            success: true,
            retryButton: false,
            loadingRequest: false,
            uploadDocumentsElement: false,
            makePaymentElement: false,
            model: {
                // list of objs
                files: [],
                fileTypes: [],
                docTypes: [],
            },
            tmpFileType: "",
            showFileUploader: false,
            errors: {},
            operations: 0,
            columns: [
                {
                    title: "Type",
                    dataIndex: "dataType",
                    key: "dataType",
                },
            ],
        };
    },
    methods: {

        login() {
            this.$router.push("/account-opening/login");
        }
        ,
        setDefaults() {

            this.message = 'Thank you for updating the documents, we will review and restart the account opening process.';
            this.title = 'Done!';
            this.subTitle = 'Documents Updated';
            this.success = true;
            this.retryButton = false;
            this.logoutButton = true;
            this.loadingRequest = false;
        },

        showUploadDocuments() {
            this.uploadDocumentsElement = true;
        },
        removeItem(item) {
            let index = this.model.files.indexOf(item);
            if (index > -1) {
                this.model.files.splice(index, 1);
            }
        },
        startImageUpload(item) {
            this.tmpFileType = item;
            this.showFileUploader = true;

        },
        cancel() {
            this.model.files = null;
        },
        storeImageUpload(info) {
            this.model.files.push(info.file);
            this.model.docTypes.push(this.tmpFileType);
            this.model.files.splice(-1);
            console.table(this.model.files);
            console.table(this.model.docTypes);

            console.log(info.file);

            this.showFileUploader = false;
        },
        back() {
            this.$router.push("/account-opening/view-account-applications");
        },

        async uploadFiles() {
            const total = this.model.files.length;
            let count = 0;

            for (const file of this.model.files) {
                const formData = new FormData();
                formData.append("phone", localStorage.getItem("phone-number"));
                formData.append("customerUid", localStorage.getItem("uid"));
                formData.append("documentTypeLabel", file.docType);
                formData.append("citizenId", localStorage.getItem("identity-doc-no"));
                formData.append("files", file.file);

                this.addOp();
                console.log("uploading docs");

                try {
                    const res = await http.postFormDataNoAuth(URLS.documents + "/upload", formData);
                    utils.logger("upload result", res);

                    if (res.status === 200) {
                        count++;
                        this.progress = (count / total) * 100;
                        console.log(this.progress);
                    } else {
                        console.log("error occurred");
                    }
                    this.removeOp();
                    await this.handleGetResponse(res, true);
                } catch (error) {
                    console.log("error occurred", error);
                    this.removeOp();
                }
            }

            console.log("sent!!!");

            if (count === total) {
                try {
                    const response = await this.get(URLS.accounts + '/re-activate-account-application/' + localStorage.getItem('account-uid'));
                    if (response.status === 200) {
                        this.uploadDocumentsElement = false;
                        this.makePaymentElement = true;
                        this.setDefaults();
                    }
                } catch (error) {
                    console.log("error occurred", error);
                }
            } else {
                console.log("failed to upload");
            }
        }
        ,
        beforeUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
                message.error("Document must be smaller than 2MB!");
                return false;
            }

            let newFile = {};
            newFile.file = file;
            newFile.docType = this.tmpFileType;

            this.model.files.push(newFile);
            return false;
        },

        getCustomerById() {
            http
                .getIdentity(
                    URLS.customerByPhone + localStorage.getItem("phone-number")
                ).then((res) => {
                    console.log(res);
                    localStorage.setItem("uid", res.body.uid);
                    this.addendum.customerUid = res.body.uid;

                });
        },
        getTypes() {
            this.getNoAuth(URLS.documents + "/types")
                .then((response) => (this.model.fileTypes = response.body));

            console.log(this.model.fileTypes);
        },
        ...baseMethods,
    },
    mounted() {
        this.showUploadDocuments();
        this.getTypes();
        this.getCustomerById();
    },
    computed: {

        isFormValid() {
            return (
                this.model.files.length > 0
            );
        }
    }
};
</script>

<style scoped></style>
